'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/MouseOverPhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const MouseOverPhotoSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const MouseOverPhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={MouseOverPhotoSkin} />
);

export default MouseOverPhoto;
